import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { DeleteCommentInput } from '../domain/dtos/delete-comment-input'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class DeleteComment {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient<null>,
  ) {}

  public async execute(input: DeleteCommentInput): Promise<null> {
    const response = await this.httpClient.request({
      method: HttpMethod.DELETE,
      url: `${Envs.BFF_MEMBERS_AREA_URL}/hub/posts/${input.postId}/comments/${input.commentId}`,
    })

    if (response.statusCode === HttpStatusCode.CREATED || response.statusCode === HttpStatusCode.OK) {
      return null
    }

    throw new GeneralError()
  }
}
